import { SelectableCard } from "../../shared/selectable-card";
import { CardBadge } from "../../shared/card-badge";

export type BudgetPricingOption = {
  id: string;
  title: string;
  description: string;
};

type BudgetPricingCardProps = {
  option: BudgetPricingOption;
  selected: boolean;
  onSelect: () => void;
};

export function BudgetPricingCard({
  option,
  selected,
  onSelect,
}: BudgetPricingCardProps) {
  return (
    <SelectableCard interactive selected={selected} onSelect={onSelect}>
      <div className="tw:min-w-0 tw:flex tw:h-full tw:flex-col">
        <div className="tw:flex tw:items-center tw:justify-between tw:gap-3">
          <h3 className="tw:min-w-0 tw:text-sm tw:font-semibold tw:text-foreground">
            {option.title}
          </h3>
          <CardBadge
            className={
              selected ? "tw:bg-sky-500 tw:text-white" : "tw:invisible"
            }
            aria-hidden={!selected}
          >
            Selected
          </CardBadge>
        </div>
        <p className="tw:mt-2 tw:text-sm tw:leading-relaxed tw:text-muted-foreground">
          {option.description}
        </p>
      </div>
    </SelectableCard>
  );
}
